module.exports = __webpack_public_path__ + "static/media/password.a75e9122.svg";